import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, finalize, tap, switchMap } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ErrorResponse } from 'src/app/models/error-reponse.model';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private loadingService: LoaderService,
    private utilityService: UtilityService,
    private router: Router,
    private msalService: MsalService,
    private authService: AuthService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.match(/DullImage/)) {
      return from(this.addAuthHeaderToAllowedOrigins(request)).pipe(
        switchMap(authReq => next.handle(authReq))
      );
    }
    this.totalRequests++;
    this.loadingService.setLoading(true);

    return from(this.addAuthHeaderToAllowedOrigins(request)).pipe(
      switchMap(authReq => next.handle(authReq)),
      tap((response) => {
        if (response instanceof HttpResponse) {
          if (response != null && response.url?.includes('GetDullByDullEventId')) {
            if (!response.body.isSuccess && response.body.header && response.body.message) {
              let errorResponse: ErrorResponse = {
                header: response.body.header,
                message: response.body.message
              };
              this.utilityService.setErrorResponse(errorResponse);
              this.loadingService.setLoading(false);
              this.router.navigate(['/error-page']);
            }
          }
        }
      }),
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loadingService.setLoading(false);
        }
      }),
      catchError(err => {
        if ([401].includes(err.status)) {
          this.authService.logout();
        }
        const error = err.error?.message || err.statusText;
        return throwError(() => error);
      })
    );
  }

  private addAuthHeaderToAllowedOrigins(request: HttpRequest<unknown>): Promise<HttpRequest<unknown>> {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      const requestObj = {
        scopes: environment.msalConfig.authScope,
        account: accounts[0]
      };
      return this.msalService.instance.acquireTokenSilent(requestObj).then(tokenResponse => {
        return request.clone({
          setHeaders: { 'Authorization': `Bearer ${tokenResponse.accessToken}` }
        });
      })
    } else {
      return Promise.resolve(request);
    }
  }
}
